import React, { useEffect, useState, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { AppConfirmDialog } from 'components/common/AppConfirmDialog';
import 'features/dashboard/static/downtime/grid/grid.style.css';
import { useCommonInits } from 'hooks/useCommonInits';
import {
    getAssets,
    clearDataSource,
    getPanelValue,
    getGroups,
} from 'redux/datasource/dataSourceSlice';
import { useSelector } from 'react-redux';
import {
    Typography,
    Button,
    Select,
    MenuItem,
    FormControl,
    Box,
    Paper,
} from '@mui/material';
import { AppButton } from 'app/components/shared/AppButton';
import {
    getApcmGroup,
    getAllGroups,
    deleteGroup,
    searchGroupName,
} from 'redux/datasource/dataSourceActions';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { updatePanelContent } from 'redux/panels/panelsSlice';
import CreateModal from 'components/Modal/createModal';
import { DataGrid } from '@mui/x-data-grid';
import { ROUTE_PATHS } from 'app/utils/route';

export const Groups = panel => {
    const { dispatch, select, navigate } = useCommonInits();
    const Groups = useSelector(getGroups);
    const [showDialog, setShowDialog] = useState(false);
    const [groupName, setGroupName] = useState('ALL' || '');
    const [filteredName, setFilteredName] = useState(Groups);
    const [openModal, setOpenModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [deleteData, setDeleteData] = useState({});
    const [pageSize, setPageSize] = useState(10);

    const navigateTo = (path, params = {}) => {
        navigate(path, params);
    };
    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 2;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: '22%',
            },
        },
    };
    useEffect(() => {
        if (Groups) {
            if (groupName === 'ALL') {
                dispatch(getAllGroups());
            } else {
                const params = {
                    name: groupName,
                };
                dispatch(searchGroupName(params));
            }
        }
    }, []);

    const handleLiveAssets = params => {
        navigateTo(`/${ROUTE_PATHS.assetsLiveData}/${params.row._id}`);
    };

    const handleNameChange = e => {
        handleGroupName(e);
        setFilteredName(groupName === 'ALL' ? Groups : onGroupSelect());
    };

    const renderDeleteDialog = () => (
        <AppConfirmDialog
            open={showDialog}
            title="Delete Confirmation"
            message="Are you sure you want to delete this group?"
            confirmText="Delete"
            cancelText="Cancel"
            onConfirm={selectGDelete}
            onCancel={() => setShowDialog(false)}
        />
    );

    useEffect(() => {
        if (Groups) {
            dispatch(getAllGroups());
        }
        dispatch(clearDataSource());
    }, []);

    const openDialog = id => {
        setOpenModal(true);
        if (id?.length) {
            dispatch(getApcmGroup({ id }));
        }
    };

    const onGroupSelect = () => {
        const params = {
            name: groupName,
        };
        dispatch(searchGroupName(params));
    };

    const selectGDelete = () => {
        const params = {
            _id: deleteData._id,
        };
        dispatch(deleteGroup(params));
        setShowDialog(false);
    };

    const handleDialog = data => {
        setShowDialog(true);
        setDeleteData(data);
    };

    const handleGroupName = e => {
        dispatch(
            updatePanelContent({
                groupName: e.target.value,
            }),
        );
        setGroupName(e.target.value);
    };

    const columns = useMemo(
        () => [
            {
                field: 'name',
                headerName: 'Group Name',
                width: 350,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <div>
                            <Button
                                onClick={() => handleLiveAssets(params)}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                {params.row.name}
                            </Button>
                        </div>
                    );
                },
            },
            {
                field: 'assets',
                headerName: 'Assets',
                width: 350,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'desc',
                headerName: 'Description',
                width: 220,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'created_at',
                headerName: 'Date Time',
                width: 200,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'created_by',
                headerName: 'Created By',
                width: 150,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
            },
            {
                field: 'action',
                headerName: 'Action',
                width: 150,
                sortable: false,
                filterable: false,
                editable: true,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <div>
                            <Button
                                onClick={() => openDialog(params.row._id)}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                <EditIcon />
                            </Button>
                            <Button
                                onClick={() => handleDialog(params.row)}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </div>
                    );
                },
            },
        ],
        [],
    );

    return (
        <div style={{ padding: 10 }}>
            <Paper variant="outlined">
                <Box
                    sx={{
                        marginLeft: 1,
                    }}
                >
                    <div
                        style={{
                            marginTop: '5px',
                            padding: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Typography variant={'h4'}>Group List</Typography>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <label style={{ marginLeft: '2px', marginTop: '25px' }}>
                            Groups :
                            <FormControl sx={styles.unitsSelect}>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={groupName || 'ALL'}
                                    onChange={handleNameChange}
                                    size="small"
                                    MenuProps={MenuProps}
                                >
                                    <MenuItem value="ALL">ALL</MenuItem>

                                    {Groups.map((item, index) => {
                                        return (
                                            <MenuItem
                                                value={item.name}
                                                key={`item-${index}`}
                                            >
                                                {item.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </label>
                        <AppButton
                            variant={'outlined'}
                            style={{
                                cursor: 'pointer',
                                marginTop: '22px',

                                marginRight: 2,
                                marginBottom: '15px',
                            }}
                            action={openDialog}
                        >
                            Add Group
                        </AppButton>
                    </div>
                </Box>
            </Paper>

            <Paper sx={{ marginTop: '10px' }}>
                <Box>
                    <DataGrid
                        disableColumnMenu
                        rows={
                            groupName === 'ALL'
                                ? Groups
                                : Groups.filter(data => data.name === groupName)
                        }
                        columns={columns}
                        getRowId={row => row._id}
                        rowsPerPageOptions={[10, 25, 50]}
                        autoHeight={true}
                        pageSize={pageSize}
                        onPageSizeChange={newPage => setPageSize(newPage)}
                        getRowSpacing={params => ({
                            top: params.isFirstVisible ? 0 : -2,
                            bottom: params.isLastVisible ? 0 : -2,
                        })}
                    />
                </Box>
            </Paper>

            {showDialog && renderDeleteDialog()}
            {openModal && (
                <CreateModal
                    isOpen={openModal}
                    handleCloseModal={() => setOpenModal(false)}
                    handleEdited={openDialog}
                />
            )}
        </div>
    );
};

const styles = {
    unitsSelect: {
        width: 400,
        marginLeft: 1,
        marginBottom: 1,
        color: 'white',
    },
    addButton: {
        display: 'flex',
        justifyContent: 'right',
    },
};
